import React from "react";
import "./billing.css";

const Billing = () => {
  return (
    <div className="billing-page">
      <div className="billing-page-content">
        <div className="billing-page-header">
          <div className="billing-page-header-top">
            <div className="billing-page-header-content">
              <div className="billing-page-heading">Billing</div>
            </div>
          </div>
        </div>
        <div className="billing-data-table">
          <div className="billing-data-table-1">
            <div className="billing-data-table-header">
              <div className="billing-data-table-header-cell">
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <span
                    class="text-label truncate"
                    style={{ display: "block" }}
                  >
                    Community
                  </span>
                  <span class="icon">
                    <svg
                      viewBox="0 0 13 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <path
                        class="up"
                        d="M5.981.208a.75.75 0 011.037 0l5.75 5.5A.751.751 0 0112.25 7H.75a.749.749 0 01-.518-1.292l5.75-5.5z"
                        fill="#D3D7DA"
                      ></path>
                      <path
                        class="down"
                        d="M.75 9h11.5a.75.75 0 01.518 1.292l-5.75 5.5a.748.748 0 01-1.037 0l-5.75-5.5A.751.751 0 01.75 9z"
                        fill="#D3D7DA"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="billing-data-table-header-cell">
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <span
                    class="text-label truncate"
                    style={{ display: "block" }}
                  >
                    Charged Students
                  </span>
                  <span class="icon">
                    <svg
                      viewBox="0 0 13 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <path
                        class="up"
                        d="M5.981.208a.75.75 0 011.037 0l5.75 5.5A.751.751 0 0112.25 7H.75a.749.749 0 01-.518-1.292l5.75-5.5z"
                        fill="#D3D7DA"
                      ></path>
                      <path
                        class="down"
                        d="M.75 9h11.5a.75.75 0 01.518 1.292l-5.75 5.5a.748.748 0 01-1.037 0l-5.75-5.5A.751.751 0 01.75 9z"
                        fill="#D3D7DA"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="billing-data-table-header-cell">
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <span
                    class="text-label truncate"
                    style={{ display: "block" }}
                  >
                    Cost
                  </span>
                  <span class="icon">
                    <svg
                      viewBox="0 0 13 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <path
                        class="up"
                        d="M5.981.208a.75.75 0 011.037 0l5.75 5.5A.751.751 0 0112.25 7H.75a.749.749 0 01-.518-1.292l5.75-5.5z"
                        fill="#D3D7DA"
                      ></path>
                      <path
                        class="down"
                        d="M.75 9h11.5a.75.75 0 01.518 1.292l-5.75 5.5a.748.748 0 01-1.037 0l-5.75-5.5A.751.751 0 01.75 9z"
                        fill="#D3D7DA"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="billing-data-table-header-cell">
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <span
                    class="text-label truncate"
                    style={{ display: "block" }}
                  >
                    Payment Date
                  </span>
                  <span class="icon">
                    <svg
                      viewBox="0 0 13 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <path
                        class="up"
                        d="M5.981.208a.75.75 0 011.037 0l5.75 5.5A.751.751 0 0112.25 7H.75a.749.749 0 01-.518-1.292l5.75-5.5z"
                        fill="#D3D7DA"
                      ></path>
                      <path
                        class="down"
                        d="M.75 9h11.5a.75.75 0 01.518 1.292l-5.75 5.5a.748.748 0 01-1.037 0l-5.75-5.5A.751.751 0 01.75 9z"
                        fill="#D3D7DA"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div className="billing-data-table-body">
              <div className="billing-data-table-row-odd">
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      Staging Test 45
                    </div>
                  </div>
                </div>
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      1
                    </div>
                  </div>
                </div>
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      5
                    </div>
                  </div>
                </div>
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      July 01, 2024
                    </div>
                  </div>
                </div>
              </div>
              <div className="billing-data-table-row-even">
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      Staging Test 45
                    </div>
                  </div>
                </div>
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      1
                    </div>
                  </div>
                </div>
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      5
                    </div>
                  </div>
                </div>
                <div className="billing-data-table-row-name">
                  <div className="billing-data-table-row-name-body">
                    <div style={{ display: "block", width: "max-content" }}>
                      July 01, 2024
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Billing;
